import React, { useCallback, useEffect } from "react";
import { producaov2 as api } from "../../../../../../services/apis";
import { SemanticTable } from "./styled";
import { Button, Dimmer, Icon, Loader, Modal } from "semantic-ui-react";
import swal from "sweetalert";
import { consolidateStreamedStyles } from "styled-components";

const ScrollingModal = (empresa) => {
  const [open, setOpen] = React.useState(false);
  const [load, setLoad] = React.useState();
  const [andamento, setAndamento] = React.useState();

  const saveData = async () => {
    try {
      const params = {
        id: empresa.empresa.id,
        status: andamento,
      };

      await api.put(`/admin/empresas/solicitacoes/editar`, {
        params,
      });

      swal("Andamento atualizado com sucesso!", "", "");
    } catch (err) {
      console.error(err);
      swal(
        "Não foi possível atualizar o andamento, tente novamente mais tarde",
        "",
        ""
      );
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      trigger={<Button>Editar andamento</Button>}
    >
      <Modal.Header>{empresa.empresa.id}</Modal.Header>
      {load && (
        <Dimmer active>
          <Loader />
        </Dimmer>
      )}
      <Modal.Content image scrolling>
        <Modal.Description>
          <SemanticTable size="big" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>
                  Nome da Empresa
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Curso</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Licenças</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Editar andamento
                </SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>
            <SemanticTable.Body>
              <SemanticTable.Row>
                <SemanticTable.Cell>
                  {empresa.empresa.empresa.nome}
                </SemanticTable.Cell>
                <SemanticTable.Cell>{empresa.empresa.curso}</SemanticTable.Cell>
                <SemanticTable.Cell>
                  {empresa.empresa.licencas}
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  <select onChange={(e) => setAndamento(e.target.value)}>
                    <option value="0">Não iniciado</option>
                    <option value="1">Em andamento</option>
                    <option value="2">Finalizado</option>
                  </select>
                </SemanticTable.Cell>
              </SemanticTable.Row>
            </SemanticTable.Body>
          </SemanticTable>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)} color="red">
          Fechar <Icon name="x icon" />
        </Button>
        <Button onClick={saveData} color="green">
          Salvar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ScrollingModal;
